// useUserOnboarding.jsx


import { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import app from '../firebase';
import { db as firestore } from "../firebase" 
const storage = getStorage(app);

export const useUserOnboarding = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const uploadFile = async (userId, file, folder) => {
    const storageRef = ref(storage, `users/${userId}/${folder}/${file.name}`);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  };

  const saveOnboardingData = async (userId, data, section = 'onboarding') => {
    const userRef = doc(firestore, 'users', userId);
    try {
      await updateDoc(userRef, {
        [section]: {
          ...data,
          updatedAt: new Date().toISOString(),
        },
      });
    } catch (err) {
      throw new Error(`Failed to save ${section} data: ${err.message}`);
    }
  };

  const submitUserOnboarding = async (userId, onboardingData) => {
    setLoading(true);
    setError('');
    try {
      const userRef = doc(firestore, 'users', userId);
      // This will save everything in onboardingData (including idDocument/headshot etc)
      await updateDoc(userRef, {
        ...onboardingData,
        updatedAt: new Date().toISOString(),
      });
    } catch (err) {
      setError(`Failed to save onboarding data: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };


  const submitUserQuestionnaire = async (userId, questionnaireData) => {
    setLoading(true);
    setError('');

    try {
      await saveOnboardingData(userId, questionnaireData, 'onboarding.questionnaire');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    uploadFile,
    submitUserOnboarding,
    submitUserQuestionnaire,
  };
};
